import { useQuery } from "@tanstack/react-query";

import { getProductOffer } from "../../../api/getProductOffer";
import { useSalesContext } from "../../../sales-context/SalesContext";
import { useProductOfferStore } from "../../../stores";
import { EligibilityStatus, SaleProgress } from "../../../types";

export const useProductOfferPolling = () => {
    const { sessionId, partner, logger, apiClients, analytics } = useSalesContext();

    const primaryProducts = useProductOfferStore((state) => state.getPrimaryProducts(sessionId));
    const updateProduct = useProductOfferStore((state) => state.updateProduct);
    const primaryProduct = primaryProducts.at(0);

    const isEnabled =
        !!primaryProduct &&
        primaryProduct.status === EligibilityStatus.Eligible &&
        primaryProduct.saleProgress === SaleProgress.InProgress;

    const { data, isLoading, isError } = useQuery({
        queryKey: [`sales-product-offer`, primaryProduct?.id, partner, primaryProduct?.salesProvider],
        queryFn: async () => {
            return primaryProduct
                ? getProductOffer(
                      apiClients.sales,
                      logger,
                      analytics.dispatcher,
                      primaryProduct.id,
                      partner,
                      primaryProduct.salesProvider,
                      sessionId,
                  )
                : undefined;
        },
        refetchInterval: (isEnabled) => (isEnabled ? 15000 : false),
        enabled: isEnabled && partner === "mcafee",
    });

    if (!isLoading && !isError && !!data && primaryProduct && isEnabled) {
        if (
            primaryProduct.id === data.productOfferId &&
            (data.enrollmentStatus === "SUCCESS" || data.enrollmentStatus === "FAILURE")
        ) {
            updateProduct(sessionId, data.productOfferId, {
                saleProgress: data.enrollmentStatus.toString() as SaleProgress,
            });
        }
    }
};
